/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PeopleCircle1Icon16Solid = forwardRef('PeopleCircle1Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0ZM4.067 11.986C4.8 10.165 6.87 10.025 8 10.025s3.2.14 3.933 1.96A5.582 5.582 0 0 1 8 13.6a5.582 5.582 0 0 1-3.933-1.614ZM8.004 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" })));
});
